import { AbilityBuilder, Ability } from '@casl/ability'

/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */



function defineAbilitiesFor(user){
  const { rules, can, cannot } = AbilityBuilder.extract()
  //can('update', 'Rule')
  can('update', 'OwnUser')
  if (user.role == 'admin'){
      can('update', ['Rule', 'Equipment', 'Facility', 'Points', 'Config', 'Parameter','AnomalyDescription', 'KPI', 'Report','Dates','Graphic','Script',
        'MaintenanceRecord',
        'EquipmentServicingSchedule',
        'Model',
        'Autotuner',
      ])
      can('update', 'Notification')
      can('update', 'GraphicalView')
      //can('manage', 'all')
      can('create', 'Users')
      can('update', 'Users')
      can('delete', 'Users')
      can('delete', 'Dates')
      can('delete', 'KPI')
      can('update', 'SoftwareSwitches')
      can('manage','job')
      can('manage','model')
      can('manage','executiveSummary')
      can('manage','Connector')
      can('update', 'CustomViews')
    } else if (user.role == 'maintainer'){
      can('update', 'MaintenanceRecord')
      can('update', 'Notification')
      can('update', 'SoftwareSwitches')
      can('update', 'CustomViews')
    } else if (user.role == 'operator'){
      can('update', 'CustomViews')
    } else{
      can('read', 'all')
      //can('udpate', 'Users', {user:user})
      }

  return rules
}

function updateAbility(user) {
  ability.update(defineAbilitiesFor(user))
}

let ability = new Ability(defineAbilitiesFor({role: 'admin'}))
updateAbility({role: 'admin'})


export {ability, updateAbility}
